import React, { useContext } from 'react';
import Home from './home/Home';
import useHomesManager from './model/HomesManager';
import NewHome from './home/new-home/NewHome';
import useProfile from './model/Profile';
import useAddToHomeScreen from './model/AddToHomeScreen';
import useServiceWorkerController from './model/ServiceWorkerController';
import FullPageTransition from './home/general-components/FullPageTransition';
import { HistoryStackProvider } from './home/general-components/HistoryStackContext';
import { LocalizationContextProvider } from './localization/Context';
import { WebViewManagerContext, WebViewManagerContextProvider } from './home/general-components/WebViewManagerContext';

// import { AnalyticsProvider } from './model/Analytics';
import { isiOS, isInWebAppiOS } from './home/general-components/BrowserUtils';
import AddToHomeScreen from './home/add-to-home-sceen/AddToHomeScreen';
import useWindowDimensions from './home/general-components/WindowDimensions';

import './Mixins.scss';
import './App.scss';
import './Common.scss';

// import Playground from './playground/Playground';

function App({ serviceWorkerConfigRef }) {
  // service worker controller
  const swController = useServiceWorkerController(serviceWorkerConfigRef);

  // return <Playground />; // eslint-disable-next-line
  return (
    // <AnalyticsProvider>
    <WebViewManagerContextProvider>
      <HistoryStackProvider>
        <LocalizationContextProvider>
          <AppLoader swController={swController} />
        </LocalizationContextProvider>
      </HistoryStackProvider>
    </WebViewManagerContextProvider>
    // </AnalyticsProvider>
  )
}

function AppLoader({ swController }) {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions();
  const wm = useContext(WebViewManagerContext);

  const homesManager = useHomesManager(swController);
  const profile = useProfile();
  const [snooze, itIsTimeToShowTheHomeScreenMessage] = useAddToHomeScreen();

  const needToShowAddToHomeScreen = itIsTimeToShowTheHomeScreenMessage && isiOS() && !isInWebAppiOS() && !wm.inWebView;

  return (
    <FullPageTransition disableOnFirstTime>
      <AddToHomeScreen
        snooze={snooze}

        isVisible={needToShowAddToHomeScreen}
        key="app-addtohomescreen" />

      <NewHome
        homesManager={homesManager}
        profile={profile}
        windowWidth={windowWidth} windowHeight={windowHeight}

        isVisible={!needToShowAddToHomeScreen && homesManager.inNewHomeProcess}
        key="app-newhome" />

      <Home
        homesManager={homesManager}
        profile={profile}
        swController={swController}
        windowWidth={windowWidth} windowHeight={windowHeight}

        isVisible={!needToShowAddToHomeScreen && !homesManager.inNewHomeProcess}
        key="app-home" />
    </FullPageTransition>
  )
}

export default App;
